// extracted by mini-css-extract-plugin
export default {"steps":"step_steps__oiGfs","lines":"step_lines__Hb6Mm","header":"step_header__8Ws6g","content":"step_content__ark6x"};